import React from "react";
import { buttonClasses } from "@mui/material";
import { GridColDef, GridToolbarContainer } from "@mui/x-data-grid-premium";

import MuiMenu from "../muiMenu";
import SettingsIcon from "@mui/icons-material/Settings";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import { CustomToolbarButton, ToolbarButtonProps } from "../customToolbar";
import { Typography } from "@mui/material";

interface CustomToolbarProps {
    columns: GridColDef[];
    title?: string;
    hiddenColumns: string[];
    setHiddenColumns: (cols: string[]) => void;
    enableColumnSelector: boolean;
    customToolbarButtons: ToolbarButtonProps[];
}

export const CustomToolbar = ({
    columns,
    title = "",
    hiddenColumns,
    setHiddenColumns,
    enableColumnSelector,
    customToolbarButtons,
}: CustomToolbarProps) => {
    return (
        <GridToolbarContainer
            sx={{
                display: "flex",
                justifyContent: "space-between",
                borderTopLeftRadius: "4px",
                borderTopRightRadius: "4px",
                alignItems: "center",
                backgroundColor: "primary.dark",
                marginBottom: "-0.2rem",
                height: "40px",
                [`.${buttonClasses.startIcon}`]: {
                    margin: 0,
                },
                [`& .${buttonClasses.root}`]: {
                    minWidth: "40px",
                },
            }}
        >
            <Typography
                sx={{
                    flexGrow: 1,
                    color: "primary.contrastText",
                    padding: "0 0 0 0.3rem",
                }}
                variant="h6"
                component="div"
            >
                {title}
            </Typography>

            {customToolbarButtons?.map((b) => (
                <CustomToolbarButton key={b.key} {...b} />
            ))}

            {enableColumnSelector ? (
                <MuiMenu
                    label={<SettingsIcon color="white" fontSize="small" />}
                    size="small"
                    keepOpenAfterSelect
                    items={columns
                        .filter((c) => c.hideable)
                        .map((c) => ({
                            label: c.headerName,
                            icon: hiddenColumns.includes(c.field) ? (
                                <CheckBoxOutlineBlankIcon />
                            ) : (
                                <CheckBoxIcon color="primary" />
                            ),
                            onClick: () =>
                                setHiddenColumns(
                                    hiddenColumns.includes(c.field)
                                        ? hiddenColumns.filter(
                                              (hc) => hc !== c.field
                                          )
                                        : [...hiddenColumns, c.field]
                                ),
                        }))}
                />
            ) : null}
        </GridToolbarContainer>
    );
};
